import moment from 'moment'
import type { Moment } from 'moment'

/**
 * The earliest date a Trip Planner calendar should allow selecting.
 *
 * Defaults to the start of today so past dates are greyed out and unselectable.
 * When an existing trip/item already starts in the past, we clamp back to that
 * date so an in-progress or historical trip stays editable.
 */
export function getCalendarMinDate(earliestExistingDate?: Moment | null): Moment {
  const startOfToday = moment().startOf('day')

  if (earliestExistingDate?.isBefore(startOfToday, 'day')) {
    return earliestExistingDate.clone().startOf('day')
  }

  return startOfToday
}
